module.exports = __webpack_public_path__ + "Flag-764.bc993ddb151e1d339418b659f5528ac7.svg";